
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M21.61 9.937A5 5 0 0022 8V5a1 1 0 00-1-1h-3a1 1 0 01-1-1 1 1 0 00-1-1H8a1 1 0 00-1 1 1 1 0 01-1 1H3a1 1 0 00-1 1v3a5 5 0 005 5c.058 0 .108.041.121.098a5 5 0 003.096 3.574c.444.17.783.57.783 1.045v.606a1 1 0 01-.629.928l-3.996 1.6A.596.596 0 006.596 22h10.808a.596.596 0 00.221-1.15l-3.996-1.599a1 1 0 01-.629-.928v-.606c0-.476.34-.875.783-1.045a5 5 0 002.883-2.873c.174-.45.587-.781 1.065-.852a5 5 0 003.88-3.01zM4.88 10.12A3 3 0 014 8V6.5a.5.5 0 01.5-.5h2a.5.5 0 01.5.5v4c0 .276-.225.504-.498.458a3 3 0 01-1.623-.837zm12.619.837A3 3 0 0020 8V6.5a.5.5 0 00-.5-.5h-2a.5.5 0 00-.5.5v4c0 .276.225.504.498.458z","fill":"#fff"}})])
          )
        }
      }
    